/*================ Shopify Common JS ================*/
if ((typeof window.Shopify) == 'undefined') {
    window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
    return function () {
        return fn.apply(scope, arguments);
    }
};

Shopify.setSelectorByValue = function (selector, value) {
    for (var i = 0, count = selector.options.length; i < count; i++) {
        var option = selector.options[i];
        if (value == option.value || value == option.innerHTML) {
            selector.selectedIndex = i;
            return i;
        }
    }
};

Shopify.addListener = function (target, eventName, callback) {
    target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
    options = options || {};
    var method = options['method'] || 'post';
    var params = options['parameters'] || {};

    var form = document.createElement("form");
    form.setAttribute("method", method);
    form.setAttribute("action", path);

    for (var key in params) {
        var hiddenField = document.createElement("input");
        hiddenField.setAttribute("type", "hidden");
        hiddenField.setAttribute("name", key);
        hiddenField.setAttribute("value", params[key]);
        form.appendChild(hiddenField);
    }
    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
    this.countryEl = document.getElementById(country_domid);
    this.provinceEl = document.getElementById(province_domid);
    this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

    if (this.countryEl) {
        Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

        this.initCountry();
        this.initProvince();
    }
};

Shopify.CountryProvinceSelector.prototype = {
    initCountry: function () {
        var value = this.countryEl.getAttribute('data-default');
        Shopify.setSelectorByValue(this.countryEl, value);
        this.countryHandler();
    },

    initProvince: function () {
        var value = this.provinceEl.getAttribute('data-default');
        if (value && this.provinceEl.options.length > 0) {
            Shopify.setSelectorByValue(this.provinceEl, value);
        }
    },

    countryHandler: function (e) {
        var opt = this.countryEl.options[this.countryEl.selectedIndex];
        var raw = opt.getAttribute('data-provinces');
        var provinces = JSON.parse(raw);

        this.clearOptions(this.provinceEl);
        if (provinces && provinces.length == 0) {
            this.provinceContainer.style.display = 'none';
        } else {
            for (var i = 0; i < provinces.length; i++) {
                var opt = document.createElement('option');
                opt.value = provinces[i][0];
                opt.innerHTML = provinces[i][1];
                this.provinceEl.appendChild(opt);
            }

            this.provinceContainer.style.display = "";
        }
    },

    clearOptions: function (selector) {
        while (selector.firstChild) {
            selector.removeChild(selector.firstChild);
        }
    },

    setOptions: function (selector, values) {
        for (var i = 0, count = values.length; i < values.length; i++) {
            var opt = document.createElement('option');
            opt.value = values[i];
            opt.innerHTML = values[i];
            selector.appendChild(opt);
        }
    }
};

Shopify.formatMoney = function (cents, format = "") {
    if (typeof cents === "string") {
        cents = cents.replace(".", "");
    }
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/, formatString = format || window.themeVariables.settings.moneyFormat;
    function defaultTo(value2, defaultValue) {
        return value2 == null || value2 !== value2 ? defaultValue : value2;
    }
    function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultTo(precision, 2);
        thousands = defaultTo(thousands, ",");
        decimal = defaultTo(decimal, ".");
        if (isNaN(number) || number == null) {
            return 0;
        }
        number = (number / 100).toFixed(precision);
        let parts = number.split("."), dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands), centsAmount = parts[1] ? decimal + parts[1] : "";
        return dollarsAmount + centsAmount;
    }
    let value = "";
    switch (formatString.match(placeholderRegex)[1]) {
        case "amount":
            value = formatWithDelimiters(cents, 2);
            break;
        case "amount_no_decimals":
            value = formatWithDelimiters(cents, 0);
            break;
        case "amount_with_space_separator":
            value = formatWithDelimiters(cents, 2, " ", ".");
            break;
        case "amount_with_comma_separator":
            value = formatWithDelimiters(cents, 2, ".", ",");
            break;
        case "amount_with_apostrophe_separator":
            value = formatWithDelimiters(cents, 2, "'", ".");
            break;
        case "amount_no_decimals_with_comma_separator":
            value = formatWithDelimiters(cents, 0, ",", ".");
            break;
        case "amount_no_decimals_with_space_separator":
            value = formatWithDelimiters(cents, 0, " ");
            break;
        case "amount_no_decimals_with_apostrophe_separator":
            value = formatWithDelimiters(cents, 0, "'");
            break;
    }
    if (formatString.indexOf("with_comma_separator") !== -1) {
        return formatString.replace(placeholderRegex, value);
    } else {
        return formatString.replace(placeholderRegex, value);
    }
}

/*================ Helper Functions ================*/
function getFocusableElements(container) {
    return Array.from(
        container.querySelectorAll(
            "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )
    );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
    var elements = getFocusableElements(container);
    var first = elements[0];
    var last = elements[elements.length - 1];

    removeTrapFocus();

    trapFocusHandlers.focusin = (event) => {
        if (
            event.target !== container &&
            event.target !== last &&
            event.target !== first
        )
            return;

        document.addEventListener('keydown', trapFocusHandlers.keydown);
    };

    trapFocusHandlers.focusout = function () {
        document.removeEventListener('keydown', trapFocusHandlers.keydown);
    };

    trapFocusHandlers.keydown = function (event) {
        if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
        // On the last focusable element and tab forward, focus the first element.
        if (event.target === last && !event.shiftKey) {
            event.preventDefault();
            first.focus();
        }

        //  On the first focusable element and tab backward, focus the last element.
        if (
            (event.target === container || event.target === first) &&
            event.shiftKey
        ) {
            event.preventDefault();
            last.focus();
        }
    };

    document.addEventListener('focusout', trapFocusHandlers.focusout);
    document.addEventListener('focusin', trapFocusHandlers.focusin);

    elementToFocus.focus();
}

function removeTrapFocus(elementToFocus = null) {
    document.removeEventListener('focusin', trapFocusHandlers.focusin);
    document.removeEventListener('focusout', trapFocusHandlers.focusout);
    document.removeEventListener('keydown', trapFocusHandlers.keydown);

    if (elementToFocus) elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
    document.querySelector(":focus-visible");
} catch {
    focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
    const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
    let currentFocusedElement = null;
    let mouseClick = null;

    window.addEventListener('keydown', (event) => {
        if (navKeys.includes(event.code.toUpperCase())) {
            mouseClick = false;
        }
    });

    window.addEventListener('mousedown', (event) => {
        mouseClick = true;
    });

    window.addEventListener('focus', () => {
        if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

        if (mouseClick) return;

        currentFocusedElement = document.activeElement;
        currentFocusedElement.classList.add('focused');

    }, true);
}

function pauseAllMedia() {
    document.querySelectorAll('.js-youtube').forEach((video) => {
        video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
    });
    document.querySelectorAll('.js-vimeo').forEach((video) => {
        video.contentWindow.postMessage('{"method":"pause"}', '*');
    });
    document.querySelectorAll('video').forEach((video) => video.pause());
    document.querySelectorAll('product-model').forEach((model) => {
        if (model.modelViewerUI) model.modelViewerUI.pause();
    });
}

function debounce(fn, wait) {
    let t;
    return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
    };
}

function fetchConfig(type = 'json') {
    return {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
    };
}

function getCookie(name) {
    var v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
    return v ? v[2] : null;
}

function setCookie(name, value, days) {
    var d = new Date;
    d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * days);
    document.cookie = name + "=" + value + ";path=/;expires=" + d.toGMTString();
}

function slideUp(target, duration = 500) {
    target.style.transitionProperty = 'height, margin, padding';
    target.style.transitionDuration = duration + 'ms';
    target.style.boxSizing = 'border-box';
    target.style.height = target.offsetHeight + 'px';
    target.offsetHeight;
    target.style.overflow = 'hidden';
    target.style.height = 0;
    target.style.paddingTop = 0;
    target.style.paddingBottom = 0;
    target.style.marginTop = 0;
    target.style.marginBottom = 0;
    window.setTimeout(() => {
        target.style.display = 'none';
        target.style.removeProperty('height');
        target.style.removeProperty('padding-top');
        target.style.removeProperty('padding-bottom');
        target.style.removeProperty('margin-top');
        target.style.removeProperty('margin-bottom');
        target.style.removeProperty('overflow');
        target.style.removeProperty('transition-duration');
        target.style.removeProperty('transition-property');
        //alert("!");
    }, duration);
}

function slideDown(target, duration = 500) {
    target.style.removeProperty('display');
    let display = window.getComputedStyle(target).display;
    if (display === 'none') display = 'block';
    target.style.display = display;
    let height = target.offsetHeight;
    target.style.overflow = 'hidden';
    target.style.height = 0;
    target.style.paddingTop = 0;
    target.style.paddingBottom = 0;
    target.style.marginTop = 0;
    target.style.marginBottom = 0;
    target.offsetHeight;
    target.style.boxSizing = 'border-box';
    target.style.transitionProperty = "height, margin, padding";
    target.style.transitionDuration = duration + 'ms';
    target.style.height = height + 'px';
    target.style.removeProperty('padding-top');
    target.style.removeProperty('padding-bottom');
    target.style.removeProperty('margin-top');
    target.style.removeProperty('margin-bottom');
    window.setTimeout(() => {
        target.style.removeProperty('height');
        target.style.removeProperty('overflow');
        target.style.removeProperty('transition-duration');
        target.style.removeProperty('transition-property');
    }, duration);
}

function slideToggle(target, duration = 500) {
    if (window.getComputedStyle(target).display === 'none') {
        return slideDown(target, duration);
    } else {
        return slideUp(target, duration);
    }
}

function fadeIn(target, duration = 500) {
    target.style.display = '';
    target.style.opacity = 0;
    var last = +new Date();
    var tick = function () {
        target.style.opacity = +target.style.opacity + (new Date() - last) / duration;
        last = +new Date();
        if (+target.style.opacity < 1) {
            (window.requestAnimationFrame && requestAnimationFrame(tick)) || setTimeout(tick, 16);
        }
    };
    tick();
}

function fadeOut(target, duration = 500) {
    target.style.display = '';
    target.style.opacity = 1;
    let last = +new Date();
    let tick = function () {
        target.style.opacity = Number(+target.style.opacity - (new Date() - last) / duration).toFixed(4);
        last = +new Date();
        if (-target.style.opacity <= 0) {
            (window.requestAnimationFrame && requestAnimationFrame(tick)) || setTimeout(tick, 16);
        } else {
            target.style.opacity = 0;
        }
    };
    tick();
}

function getSectionInnerHTML(html, selector) {
    return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
}

function atcGetSectionsToRender() {
    return [
        {
            id: 'cart-drawer__content',
            section: document.getElementById('cart-drawer__content').dataset.id,
            selector: '.cart-drawer__content',
        },
        {
            id: 'cart-icon-bubble',
            section: 'cart-icon-bubble',
            selector: '.shopify-section'
        }
    ];
}

function addToCart(body, openCart = true) {
    fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
        .then((response) => response.json())
        .then((parsedState) => {
            atcGetSectionsToRender().forEach((section => {
                const elementToReplace =
                    document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

                elementToReplace.innerHTML =
                    getSectionInnerHTML(parsedState.sections[section.section], section.selector);
            }));
        })
        .catch((e) => {
            console.error(e);
        })
        .finally(() => {
            if (openCart) {
                document.querySelector('cart-drawer').open();
            }
        });
}

const serializeForm = form => {
    const obj = {};
    const formData = new FormData(form);
    for (const key of formData.keys()) {
        obj[key] = formData.get(key);
    }
    return JSON.stringify(obj);
};

/*================ Initialize ================*/
// Micromodal
MicroModal.init({
    openClass: 'is-open',
    disableScroll: true,
    disableFocus: true,
    awaitOpenAnimation: true,
    awaitCloseAnimation: true
});

/*================ Components ================*/
var MenuDrawer = class extends HTMLElement {
    constructor() {
        super();

        this.drawer = this.drawer = document.getElementById('menu-drawer');
        this.openButtons = document.querySelectorAll('.js-open-menu');
        this.closeButtons = document.querySelectorAll('.js-close-menu');
        this.pageOverlayElement = document.querySelector('.page-overlay');

        this.drawer.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.closeMenuDrawer());
        this.bindEvents();
    }

    bindEvents() {
        this.openButtons.forEach(openBtn => openBtn.addEventListener('click', this.openMenuDrawer.bind(this)));
        this.closeButtons.forEach(closeBtn => closeBtn.addEventListener('click', this.closeMenuDrawer.bind(this)));
        this.onBodyClick = this.handleBodyClick.bind(this);
    }

    openMenuDrawer() {
        this.drawer.setAttribute('aria-hidden', false);
        this.drawer.setAttribute('aria-expanded', true);

        this.pageOverlayElement.classList.add('is-visible');
        document.body.addEventListener('click', this.onBodyClick);

        // Swap: hide hamburger, show close button
       this.openButtons.forEach(btn => btn.style.display = 'none');
       this.closeButtons.forEach(btn => btn.style.display = '');

        if (GorgiasChat) {
            GorgiasChat.hideChat(true)
        }
    }

    closeMenuDrawer() {
        this.drawer.setAttribute('aria-hidden', true);
        this.drawer.removeAttribute('aria-expanded', true);

        this.pageOverlayElement.classList.remove('is-visible');
        document.body.removeEventListener('click', this.onBodyClick);

        // Swap back: show hamburger, hide close button
        this.openButtons.forEach(btn => btn.style.display = '');
    this.closeButtons.forEach(btn => btn.style.display = 'none');

        if (GorgiasChat) {
            GorgiasChat.hideChat(false)
        }
    }

    toggleMenuButtons() {
        const parent = event.target.parentElement;
        const secondaryMenu = event.target.nextElementSibling;
    }

    handleBodyClick(evt) {
        const target = evt.target;
        if (target.classList.contains('page-overlay')) {
            this.closeMenuDrawer();
            this.pageOverlayElement.classList.remove('is-visible');
        }
    }
}

customElements.define('menu-drawer', MenuDrawer);
var QuantityInput = class extends HTMLElement {
    constructor() {
        super();
        this.input = this.querySelector('input');
        this.changeEvent = new Event('change', { bubbles: true })

        this.querySelectorAll('button').forEach(
            (button) => button.addEventListener('click', this.onButtonClick.bind(this))
        );
    }

    onButtonClick(event) {
        event.preventDefault();
        const previousValue = this.input.value;

        event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
        if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
    }
}

customElements.define('quantity-input', QuantityInput);

var VariantSelects = class extends HTMLElement {
    constructor() {
        super();
        this.addEventListener('change', this.onVariantChange);

        if (document.querySelector("#custom-amount")) {
            document.querySelector("#custom-amount").addEventListener("change", this.handleCustomValue.bind(this))
        }
    }

    handleCustomValue(event) {
        const amount = event.target.value
        const price = document.getElementById(`price-${this.dataset.section}`) || document.getElementById(`price-${this.dataset.bareSection}`)
        price.innerHTML = `$${amount}`
    }

    hasCustomValue(event) {
        if (event.target.value.includes("Custom")) {
            document.querySelector("[data-custom-amount]").classList.remove("hidden")
        } else {
            document.querySelector("[data-custom-amount]").classList.add("hidden")
            document.querySelector("#custom-amount").value = ""
        }
    }

    onVariantChange() {

        if (document.querySelector("#custom-amount")) { this.hasCustomValue(event) }

        this.updateOptions();
        this.updateMasterId();
        this.toggleAddButton(true, '', false);
        this.updatePickupAvailability();
        this.removeErrorMessage();

        if (!this.currentVariant) {
            this.toggleAddButton(true, '', true);
            this.setUnavailable();
        } else {
            this.updateMedia();
            this.updateURL();
            this.updateVariantInput();
            this.renderProductInfo();
            this.updateShareUrl();
        }
    }

    updateOptions() {
        this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
    }

    updateMasterId() {
        this.currentVariant = this.getVariantData().find((variant) => {
            return !variant.options.map((option, index) => {
                return this.options[index] === option;
            }).includes(false);
        });
    }

    updateMedia() {
        if (!this.currentVariant) return;
        if (!this.currentVariant.featured_media) return;
        const newMedia = document.querySelector(
            `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
        );

        if (!newMedia) return;
        const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
        const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
        const parent = newMedia.parentElement;
        if (parent.firstChild == newMedia) return;
        modalContent.prepend(newMediaModal);
        parent.prepend(newMedia);
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (this.stickyHeader) {
            this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
        }
        window.setTimeout(() => {
            parent.scrollLeft = 0;
            parent.querySelector('li.product__media-item').scrollIntoView({ behavior: 'smooth' });
        });
    }

    updateURL() {
        if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
        window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateShareUrl() {
        const shareButton = document.getElementById(`Share-${this.dataset.section}`);
        if (!shareButton) return;
        shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateVariantInput() {
        const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
        productForms.forEach((productForm) => {
            const input = productForm.querySelector('input[name="id"]');
            input.value = this.currentVariant.id;
            input.dispatchEvent(new Event('change', { bubbles: true }));
        });
    }

    updatePickupAvailability() {
        const pickUpAvailability = document.querySelector('pickup-availability');
        if (!pickUpAvailability) return;

        if (this.currentVariant && this.currentVariant.available) {
            pickUpAvailability.fetchAvailability(this.currentVariant.id);
        } else {
            pickUpAvailability.removeAttribute('available');
            pickUpAvailability.innerHTML = '';
        }
    }

    removeErrorMessage() {
        const section = this.closest('section');
        if (!section) return;

        const productForm = section.querySelector('product-form');
        if (productForm) productForm.handleErrorMessage();
    }

  renderProductInfo() {
  fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.bareSection || this.dataset.section}`)
    .then((response) => response.text())
    .then((responseText) => {
      const html = new DOMParser().parseFromString(responseText, 'text/html');

      /* ── Price block ── */
      const priceId = `price-${this.dataset.section}`;
      const destination = document.getElementById(priceId);
      const source = html.getElementById(priceId);
      if (source && destination) destination.innerHTML = source.innerHTML;

      const price = document.getElementById('product__price');
      if (price) {
        if (this.dataset.bareSection) {
          const barePrice = html.getElementById('product__price');
          if (barePrice) price.innerHTML = barePrice.innerHTML;
        }
        price.classList.remove('visibility-hidden');
      }

      /* ── ATC button text — update price inline ── */
      const atcSpan = document.getElementById(`atc-${this.dataset.section}`);
      if (atcSpan) {
        if (this.currentVariant.available) {
          /* Format price: cents → dollars */
          const formatted = this.formatMoney(this.currentVariant.price);
          atcSpan.textContent = `${window.variantStrings.addToCart} • ${formatted}`;
        } else {
          atcSpan.textContent = 'Notify When In Stock';
        }
      }

      /* ── Toggle add button ── */
      this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);

      /* ── Ship date ── */
      const shipDate = document.getElementById('ship-date-message');
      if (shipDate) {
        const sourceShipDate = html.getElementById('ship-date-message');
        if (sourceShipDate) shipDate.innerHTML = sourceShipDate.innerHTML;
      }

      /* ── Sticky ATC ── */
      const stickyAtc = document.querySelector(`sticky-atc[data-section-id="${this.dataset.section}"]`);
      if (stickyAtc) {
        const stickyPrice = stickyAtc.querySelector(`#sticky-price-${this.dataset.section}`);
        if (stickyPrice && price) stickyPrice.innerHTML = price.innerHTML;

        const stickyButton = stickyAtc.querySelector('button');
        if (stickyButton && stickyButton.hasAttribute('data-disabled')) {
          stickyButton.removeAttribute('data-disabled');
        }
      }
    });
}

/* ── Money formatter ── */
formatMoney(cents) {
  if (typeof cents !== 'number') cents = parseInt(cents) || 0;
  const dollars = cents / 100;
  const hasCents = cents % 100 !== 0;

  if (hasCents) {
    /* Has cents — show decimals e.g. $900.50 */
    return '$' + dollars.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  } else {
    /* Whole number — no decimals e.g. $900 */
    return '$' + Math.round(dollars).toLocaleString();
  }
}



            toggleAddButton(disable = true, text, modifyClass = true) {
            const productForm = document.getElementById(`product-form-${this.dataset.section}`);
            if (!productForm) return;
            const addButton = productForm.querySelector('[name="add"]');
            if (!addButton) return;

            if (disable) {
              addButton.setAttribute('disabled', 'disabled');
            } else {
              addButton.removeAttribute('disabled');
            }

            if (!modifyClass) return;
          }


    setUnavailable() {
        const button = document.getElementById(`product-form-${this.dataset.section}`);
        const addButton = button.querySelector('[name="add"]');
        const addButtonText = button.querySelector('[name="add"] > span');
        const price = document.getElementById(`price-${this.dataset.section}`);
        if (!addButton) return;
        addButtonText.textContent = window.variantStrings.unavailable;
        if (price) price.classList.add('visibility-hidden');
    }

    getVariantData() {
        this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
        return this.variantData;
    }
}

customElements.define('variant-selects', VariantSelects);


/* ── Sticky ATC sync — extends VariantSelects ── */
(function() {

  /* Scroll to variant picker when SELECT A SIZE is clicked */
  document.addEventListener('click', function(e) {
    var selectSize = e.target.closest('[id^="sticky-select-size-"]');
    if (!selectSize) return;

    e.preventDefault();
    e.stopPropagation();

    /* Scroll to the variant picker on the page */
    var variantPicker = document.querySelector('variant-selects, variant-radios, .variant_picker');
    if (variantPicker) {
      variantPicker.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  });

  /* Hook into VariantSelects.renderProductInfo to update sticky bar */
  var _origRenderProductInfo = VariantSelects.prototype.renderProductInfo;

  VariantSelects.prototype.renderProductInfo = function() {
    /* Call original */
    _origRenderProductInfo.call(this);

    var self    = this;
    var sectionId = this.dataset.section;
    var variant   = this.currentVariant;

    if (!variant) return;

    var stickyAtc = document.querySelector('sticky-atc[data-section-id="' + sectionId + '"]');
    if (!stickyAtc) return;

    /* Swap states */
    var selectSizeEl  = document.getElementById('sticky-select-size-' + sectionId);
    var productRowEl  = document.getElementById('sticky-product-row-' + sectionId);
    var imgEl         = document.getElementById('sticky-img-' + sectionId);
    var variantEl     = document.getElementById('sticky-price-' + sectionId);
    
    var stickyBtn     = stickyAtc.querySelector('button');

    /* Show product row, hide select size */
    if (selectSizeEl) selectSizeEl.classList.add('hidden');
    if (productRowEl) productRowEl.classList.remove('hidden');
    if (productRowEl) stickyAtc.querySelector('button').classList.remove('size_button_atc');
    


    /* Update image */
    if (imgEl) {
      var imgSrc = variant.featured_image
        ? variant.featured_image.src
        : (document.querySelector('.product__media img') || {}).src || imgEl.src;
      imgEl.src = imgSrc;
    }

    /* Update variant label */
    if (variantEl) {
      variantEl.textContent = variant.title.replace(/\s*\/\s*/g, ' | ');
    }

    /* Update button availability */
    if (stickyBtn) {
      stickyBtn.removeAttribute('data-disabled');
      if (variant.available) {
        stickyBtn.removeAttribute('disabled');
      } else {
        stickyBtn.setAttribute('disabled', 'disabled');
      }
    }
  };

})();

var VariantRadios = class extends VariantSelects {
    constructor() {
        super();
    }

    updateOptions() {
        const fieldsets = Array.from(this.querySelectorAll('fieldset'));
        this.options = fieldsets.map((fieldset) => {
            return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
        });
    }
}

customElements.define('variant-radios', VariantRadios);

var AddToCart = class extends HTMLElement {
    constructor() {
        super();

        this.button = this.querySelector('button');
        this.button.addEventListener('click', this.onButtonClick.bind(this));
    }

    onButtonClick(event) {
        event.preventDefault();
        const id = this.dataset.id;

        const body = JSON.stringify({
            items: [{
                id: id,
                quantity: 1
            }],
            sections: atcGetSectionsToRender().map((section) => section.section),
            sections_url: window.location.pathname
        });

        addToCart(body);
    }
}

customElements.define('add-to-cart', AddToCart);

var LoadMore = class extends HTMLElement {
    constructor() {
        super();

        const dataUrl = this.dataset.loadMore
        const target = this.closest(this.dataset.container).querySelector(this.dataset.target)
        const loadMoreWrapper = this.parentElement

        this.addEventListener("click", function (e) {
            e.preventDefault();

            this.classList.add("loading")

            fetch(dataUrl).then(response => response.text()).then((responseText) => {
                const html = responseText;
                const htmlContent = new DOMParser().parseFromString(html, 'text/html')

                target.innerHTML = target.innerHTML + htmlContent.querySelector(this.dataset.target).innerHTML;
                loadMoreWrapper.innerHTML = htmlContent.querySelector(".load-more-wrapper").innerHTML || ""

            })
        }.bind(this))
    }
}

customElements.define('load-more', LoadMore)

var Accordion = class extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      const parent  = this.parentElement;
      const content = this.nextElementSibling;

      if (parent.classList.contains('active')) {
        parent.classList.remove('active');
        slideUp(content, 400);
      } else {
        parent.classList.add('active');
        slideDown(content, 400);
      }
    });
  }

  connectedCallback() {
    /* If accordion already has active class (set by Liquid default_open),
       ensure the content panel is visible without animation */
    const parent  = this.parentElement;
    const content = this.nextElementSibling;

    if (parent && parent.classList.contains('active') && content) {
      /* Remove hidden class and show content immediately */
      content.classList.remove('hidden');
      content.style.display = 'flex';
    }
  }
}

customElements.define('custom-accordion', Accordion);


var FAQCategory = class extends HTMLElement {
    constructor() {
        super()

        this.addEventListener("click", function (e) {
            const id = e.target.dataset.faqId
            const faqItems = document.querySelector(`[data-category="${id}"]`)
            const container = faqItems.parentElement
            const mobileMenu = e.target.closest(".faq-menu")

            e.target.closest("ul").querySelector("faq-category.selected").classList.remove("selected")
            e.target.classList.add('selected')

            container.querySelector('.faq-section.active').classList.remove('active')
            faqItems.classList.add("active")

            mobileMenu.querySelector("[data-selected]").innerHTML = e.target.innerHTML
        })

    }
}

customElements.define('faq-category', FAQCategory)

var BackToTop = class extends HTMLElement {
    constructor() {
        super()

        this.addEventListener("click", function () {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        })
    }
}

customElements.define('back-to-top', BackToTop)

customElements.define('sticky-atc', class StickyATC extends HTMLElement {
    constructor() {
        super();

        this.submit = this.querySelector("button[name='add']")
        this.mainForm = document.querySelector(`form#${this.dataset.mainForm}`)

        this.submit.addEventListener('click', function (e) {
            e.preventDefault()
            if (this.submit.hasAttribute("data-disabled")) {
                const elementPosition = this.mainForm.getBoundingClientRect().top
                const offsetPosition = elementPosition + window.scrollY - 100
                window.scrollTo({
                    top: offsetPosition,
                    behavior: "smooth"
                })
            } else {
                e.target.classList.add('loading')
                this.mainForm.querySelector('button[type="submit"]').click()
            }

        }.bind(this))
    }
})

customElements.define('quick-add', class QuickAdd extends HTMLElement {
    constructor() {
        super();

        this.button = this.querySelector("[data-expand-quick-add]")
        this.content = this.querySelector("[data-quick-add-content]")

        this.button.addEventListener('click', function (e) {
            e.preventDefault()

            this.button.classList.add("hidden")

            slideDown(this.content)

        }.bind(this))
    }
})

// search

class SearchForm extends HTMLElement {
    constructor() {
        super();
        this.input = this.querySelector('input[type="search"]');
        this.resetButton = this.querySelector('button[type="reset"]');

        if (this.input) {
            this.input.form.addEventListener('reset', this.onFormReset.bind(this));
            this.input.addEventListener(
                'input',
                debounce((event) => {
                    this.onChange(event);
                }, 300).bind(this)
            );
        }
    }

    toggleResetButton() {
        const resetIsHidden = this.resetButton.classList.contains('hidden');
        if (this.input.value.length > 0 && resetIsHidden) {
            this.resetButton.classList.remove('hidden');
        } else if (this.input.value.length === 0 && !resetIsHidden) {
            this.resetButton.classList.add('hidden');
        }
    }

    onChange() {
        this.toggleResetButton();
    }

    shouldResetForm() {
        return !document.querySelector('[aria-selected="true"] a');
    }

    onFormReset(event) {
        // Prevent default so the form reset doesn't set the value gotten from the url on page load
        event.preventDefault();
        // Don't reset if the user has selected an element on the predictive search dropdown
        if (this.shouldResetForm()) {
            this.input.value = '';
            this.input.focus();
            this.toggleResetButton();
        }
    }
}

customElements.define('search-form', SearchForm);

class PredictiveSearch extends SearchForm {
    constructor() {
        super();
        this.cachedResults = {};
        this.predictiveSearchResults = this.querySelector('[data-predictive-search]');
        this.allPredictiveSearchInstances = document.querySelectorAll('predictive-search');
        this.isOpen = false;
        this.abortController = new AbortController();
        this.searchTerm = '';

        this.setupEventListeners();
    }

    setupEventListeners() {
        this.input.form.addEventListener('submit', this.onFormSubmit.bind(this));

        this.input.addEventListener('focus', this.onFocus.bind(this));
        // this.addEventListener('focusout', this.onFocusOut.bind(this));
        this.addEventListener('keyup', this.onKeyup.bind(this));
        this.addEventListener('keydown', this.onKeydown.bind(this));
    }

    getQuery() {
        return this.input.value.trim();
    }

    onChange() {
        super.onChange();
        const newSearchTerm = this.getQuery();
        if (!this.searchTerm || !newSearchTerm.startsWith(this.searchTerm)) {
            // Remove the results when they are no longer relevant for the new search term
            // so they don't show up when the dropdown opens again
            this.querySelector('#predictive-search-results-groups-wrapper')?.remove();
        }

        // Update the term asap, don't wait for the predictive search query to finish loading
        this.updateSearchForTerm(this.searchTerm, newSearchTerm);

        this.searchTerm = newSearchTerm;

        if (!this.searchTerm.length) {
            this.close(true);
            return;
        }

        this.getSearchResults(this.searchTerm);
    }

    onFormSubmit(event) {
        if (!this.getQuery().length || this.querySelector('[aria-selected="true"] a')) event.preventDefault();
    }

    onFormReset(event) {
        super.onFormReset(event);
        if (super.shouldResetForm()) {
            this.searchTerm = '';
            this.abortController.abort();
            this.abortController = new AbortController();
            this.closeResults(true);
        }
    }

    onFocus() {
        const currentSearchTerm = this.getQuery();

        if (!currentSearchTerm.length) return;

        if (this.searchTerm !== currentSearchTerm) {
            // Search term was changed from other search input, treat it as a user change
            this.onChange();
        } else if (this.getAttribute('results') === 'true') {
            this.open();
        } else {
            this.getSearchResults(this.searchTerm);
        }
    }

    onFocusOut() {
        setTimeout(() => {
            if (!this.contains(document.activeElement)) this.close();
        });
    }

    onKeyup(event) {
        if (!this.getQuery().length) this.close(true);
        event.preventDefault();

        switch (event.code) {
            case 'ArrowUp':
                this.switchOption('up');
                break;
            case 'ArrowDown':
                this.switchOption('down');
                break;
            case 'Enter':
                this.selectOption();
                break;
        }
    }

    onKeydown(event) {
        // Prevent the cursor from moving in the input when using the up and down arrow keys
        if (event.code === 'ArrowUp' || event.code === 'ArrowDown') {
            event.preventDefault();
        }
    }

    updateSearchForTerm(previousTerm, newTerm) {
        const searchForTextElement = this.querySelector('[data-predictive-search-search-for-text]');
        const currentButtonText = searchForTextElement?.innerText;
        if (currentButtonText) {
            if (currentButtonText.match(new RegExp(previousTerm, 'g')).length > 1) {
                // The new term matches part of the button text and not just the search term, do not replace to avoid mistakes
                return;
            }
            const newButtonText = currentButtonText.replace(previousTerm, newTerm);
            searchForTextElement.innerText = newButtonText;
        }
    }

    switchOption(direction) {
        if (!this.getAttribute('open')) return;

        const moveUp = direction === 'up';
        const selectedElement = this.querySelector('[aria-selected="true"]');

        // Filter out hidden elements (duplicated page and article resources) thanks
        // to this https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/offsetParent
        const allVisibleElements = Array.from(this.querySelectorAll('li, button.predictive-search__item')).filter(
            (element) => element.offsetParent !== null
        );
        let activeElementIndex = 0;

        if (moveUp && !selectedElement) return;

        let selectedElementIndex = -1;
        let i = 0;

        while (selectedElementIndex === -1 && i <= allVisibleElements.length) {
            if (allVisibleElements[i] === selectedElement) {
                selectedElementIndex = i;
            }
            i++;
        }

        this.statusElement.textContent = '';

        if (!moveUp && selectedElement) {
            activeElementIndex = selectedElementIndex === allVisibleElements.length - 1 ? 0 : selectedElementIndex + 1;
        } else if (moveUp) {
            activeElementIndex = selectedElementIndex === 0 ? allVisibleElements.length - 1 : selectedElementIndex - 1;
        }

        if (activeElementIndex === selectedElementIndex) return;

        const activeElement = allVisibleElements[activeElementIndex];

        activeElement.setAttribute('aria-selected', true);
        if (selectedElement) selectedElement.setAttribute('aria-selected', false);

        this.input.setAttribute('aria-activedescendant', activeElement.id);
    }

    selectOption() {
        const selectedOption = this.querySelector('[aria-selected="true"] a, button[aria-selected="true"]');

        if (selectedOption) selectedOption.click();
    }

    getSearchResults(searchTerm) {
        const queryKey = searchTerm.replace(' ', '-').toLowerCase();
        this.setLiveRegionLoadingState();

        if (this.cachedResults[queryKey]) {
            this.renderSearchResults(this.cachedResults[queryKey]);
            return;
        }

        fetch(`${routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&resources[type]=product&resources[limit]=4&section_id=predictive-search`, {

            signal: this.abortController.signal,
        })
            .then((response) => {
                if (!response.ok) {
                    var error = new Error(response.status);
                    this.close();
                    throw error;
                }

                return response.text();
            })
            .then((text) => {
                const resultsMarkup = new DOMParser()
                    .parseFromString(text, 'text/html')
                    .querySelector('#shopify-section-predictive-search').innerHTML;
                // Save bandwidth keeping the cache in all instances synced
                this.allPredictiveSearchInstances.forEach((predictiveSearchInstance) => {
                    predictiveSearchInstance.cachedResults[queryKey] = resultsMarkup;
                });
                this.renderSearchResults(resultsMarkup);
            })
            .catch((error) => {
                if (error?.code === 20) {
                    // Code 20 means the call was aborted
                    return;
                }
                this.close();
                throw error;
            });
    }

    setLiveRegionLoadingState() {
        this.statusElement = this.statusElement || this.querySelector('.predictive-search-status');
        this.loadingText = this.loadingText || this.getAttribute('data-loading-text');

        this.setLiveRegionText(this.loadingText);
        this.setAttribute('loading', true);
    }

    setLiveRegionText(statusText) {
        this.statusElement.setAttribute('aria-hidden', 'false');
        this.statusElement.textContent = statusText;

        setTimeout(() => {
            this.statusElement.setAttribute('aria-hidden', 'true');
        }, 1000);
    }

    renderSearchResults(resultsMarkup) {
        this.predictiveSearchResults.innerHTML = resultsMarkup;
        this.setAttribute('results', true);

        this.setLiveRegionResults();
        this.open();
    }

    setLiveRegionResults() {
        this.removeAttribute('loading');
        this.setLiveRegionText(this.querySelector('[data-predictive-search-live-region-count-value]').textContent);
    }

    getResultsMaxHeight() {
        this.resultsMaxHeight = 'none';
        // this.resultsMaxHeight =
        //     window.innerHeight - document.querySelector('.header-wrapper').getBoundingClientRect().bottom - document.querySelector('.header__search').offsetHeight;
        // return this.resultsMaxHeight;
        return 0;
    }

    open() {
        // this.predictiveSearchResults.style.maxHeight = this.resultsMaxHeight || `${this.getResultsMaxHeight()}px`;
        this.predictiveSearchResults.style.maxHeight = 'none'
        this.setAttribute('open', true);
        this.input.setAttribute('aria-expanded', true);
        this.isOpen = true;
    }

    close(clearSearchTerm = false) {
        this.closeResults(clearSearchTerm);
        this.isOpen = false;
    }

    closeResults(clearSearchTerm = false) {
        if (clearSearchTerm) {
            this.input.value = '';
            this.removeAttribute('results');
        }
        const selected = this.querySelector('[aria-selected="true"]');

        if (selected) selected.setAttribute('aria-selected', false);

        this.input.setAttribute('aria-activedescendant', '');
        this.removeAttribute('loading');
        this.removeAttribute('open');
        this.input.setAttribute('aria-expanded', false);
        this.resultsMaxHeight = false;
        this.predictiveSearchResults.removeAttribute('style');
    }
}

customElements.define('predictive-search', PredictiveSearch);

const productCarousels = document.querySelectorAll('.swiper[data-product-carousel]') || null

if (productCarousels) {
    productCarousels.forEach(carousel => {
        const swiper = new Swiper(carousel, {
            slidesPerView: 1.125,
            slidesPerGroup: 1,
            spaceBetween: 16,
            centeredSlides: true,
            loop: true,
            loopAdditionalSlides: 10,
            breakpoints: {
                600: {
                    slidesPerView: 4,
                    spaceBetween: 16,
                    slidesPerGroup: 3,
                    centeredSlides: false,
                },
                1200: {
                    slidesPerView: 'auto',
                    spaceBetween: 16,
                    slidesPerGroup: 3,
                    centeredSlides: false,
                },
                1439: {
                    slidesPerView: 'auto',
                    spaceBetween: 16,
                    slidesPerGroup: 3,
                    centeredSlides: false,
                }
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            }
        })
    })
}

class ReadMore extends HTMLElement {
    constructor() {
        super()
        this.addEventListener("click", this.handleClick.bind(this))
    }

    handleClick(e) {
        e.preventDefault()
        if (this.textContent == "Read More") {
            this.previousElementSibling.firstElementChild.classList.add('hidden')
            this.previousElementSibling.lastElementChild.classList.remove('hidden')
            this.textContent = "Read Less"
        } else {
            this.previousElementSibling.firstElementChild.classList.remove('hidden')
            this.previousElementSibling.lastElementChild.classList.add('hidden')
            this.textContent = "Read More"
        }
    }

}

customElements.define('read-more', ReadMore);

class GiftNote extends HTMLElement {
    constructor() {
        super()

        this.preview = this.querySelector(".gift-note__preview")
        this.modal = this.closest(".modal")
        this.setScale = 0.92

        this.textarea = this.querySelector("textarea")
        this.submit = this.querySelector("[name='add-note']")

        window.onload = this.handleResize.bind(this)
        window.onresize = this.handleResize.bind(this)

        this.textarea.addEventListener("keypress", this.handleKeyPress.bind(this))
        this.textarea.addEventListener("keyup", this.handleMessageInput.bind(this))
        this.submit.addEventListener("click", this.handleSubmit.bind(this))
    }

    connectedCallback() {
        this.handleMessageInput()
    }

    handleResize() {
        this.setScale = ((this.offsetWidth * 0.92) / 600).toFixed(3)
        this.preview.style.setProperty("--scale-preview", this.setScale)
        this.preview.nextElementSibling.style.setProperty('margin-top', `-${390 - (this.offsetWidth * 0.92 * 0.7)}px`)
    }

    handleKeyPress(event) {
        if (event) {
            if (event.keyCode === 13 || event.key === 'Enter' || event.code === 'Enter') {
                event.preventDefault();
            }
        }
    }

    handleMessageInput(event) {
        this.value = this.textarea.value
        this.textarea.nextElementSibling.textContent = `${185 - this.textarea.value.length} character${185 - this.textarea.value.length == 1 ? 's' : ''} remaining.`
    }

    handleSubmit(event) {
        event.preventDefault();
        const note = {}
        note.messageTo = this.querySelector("[name='messageTo']").value.replace(/[\u{1F600}-\u{1F64F}\u{1F300}-\u{1F5FF}\u{1F680}-\u{1F6FF}\u{1F700}-\u{1F77F}\u{1F780}-\u{1F7FF}\u{1F800}-\u{1F8FF}\u{1F900}-\u{1F9FF}\u{1FA00}-\u{1FA6F}\u{1FA70}-\u{1FAFF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}\u{FE0F}]/gu, '')
        note.messageText = this.querySelector("[name='messageText']").value.replace(/[\u{1F600}-\u{1F64F}\u{1F300}-\u{1F5FF}\u{1F680}-\u{1F6FF}\u{1F700}-\u{1F77F}\u{1F780}-\u{1F7FF}\u{1F800}-\u{1F8FF}\u{1F900}-\u{1F9FF}\u{1FA00}-\u{1FA6F}\u{1FA70}-\u{1FAFF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}\u{FE0F}]/gu, '').replace(/\s\s+/g, ' ')
        note.messageSignOff = this.querySelector("[name='messageSignOff']").value.replace(/[\u{1F600}-\u{1F64F}\u{1F300}-\u{1F5FF}\u{1F680}-\u{1F6FF}\u{1F700}-\u{1F77F}\u{1F780}-\u{1F7FF}\u{1F800}-\u{1F8FF}\u{1F900}-\u{1F9FF}\u{1FA00}-\u{1FA6F}\u{1FA70}-\u{1FAFF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}\u{FE0F}]/gu, '')
        note.messageFrom = this.querySelector("[name='messageFrom']").value.replace(/[\u{1F600}-\u{1F64F}\u{1F300}-\u{1F5FF}\u{1F680}-\u{1F6FF}\u{1F700}-\u{1F77F}\u{1F780}-\u{1F7FF}\u{1F800}-\u{1F8FF}\u{1F900}-\u{1F9FF}\u{1FA00}-\u{1FA6F}\u{1FA70}-\u{1FAFF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}\u{FE0F}]/gu, '')

        fetch(window.Shopify.routes.root + 'cart/update.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                note: JSON.stringify(note)
            })
        })
            .then(response => response.json())
            .then(data => {
                window.location = "/checkout"
            });
    }
}
customElements.define('gift-note', GiftNote);




/* ─────────────────────────────────────────
   ProductMediaGallery
   Handles desktop scroll-sync + mobile Swiper
   Works with VariantColorGallery reordering
───────────────────────────────────────── */
/* ─────────────────────────────────────────
   ProductMediaGallery
   assets/product-media-gallery.js
───────────────────────────────────────── */
class ProductMediaGallery {
  constructor(sectionId) {
    this.id          = sectionId;
    this.mobSwiper   = null;
    this._desktopObs = null;

    this.initDesktop();
    this.initMobile();

    ProductMediaGallery._instances = ProductMediaGallery._instances || {};
    ProductMediaGallery._instances[sectionId] = this;
  }

  /* ════════════════════════════════
     DESKTOP
  ════════════════════════════════ */
  initDesktop() {
    var wrap     = document.getElementById('pmg-desktop-' + this.id);
    var mainGrid = document.getElementById('pmg-desk-main-' + this.id);
    if (!wrap || !mainGrid) return;

    this._bindDesktopThumbs();
    this._observeDesktopScroll();
  }

  _bindDesktopThumbs() {
    var self      = this;
    var thumbWrap = document.getElementById('pmg-desk-thumbs-' + this.id);
    if (!thumbWrap) return;

    var thumbs = thumbWrap.querySelectorAll('[data-pmg-desk-thumb]');
    thumbs.forEach(function(thumb) {
      var fresh = thumb.cloneNode(true);
      thumb.parentNode.replaceChild(fresh, thumb);

      fresh.addEventListener('click', function() {
        var origIdx  = parseInt(fresh.dataset.origIndex !== undefined ? fresh.dataset.origIndex : fresh.dataset.index);
        var mainGrid = document.getElementById('pmg-desk-main-' + self.id);
        if (!mainGrid) return;

        var target = mainGrid.querySelector('[data-orig-index="' + origIdx + '"]:not([style*="display: none"])')
                  || mainGrid.querySelector('[data-index="' + origIdx + '"]:not([style*="display: none"])');

        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        self._setDesktopActive(origIdx);
      });
    });
  }

  _observeDesktopScroll() {
    var self     = this;
    var mainGrid = document.getElementById('pmg-desk-main-' + this.id);
    if (!mainGrid) return;

    if (this._desktopObs) {
      this._desktopObs.disconnect();
      this._desktopObs = null;
    }

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          var origIdx = parseInt(
            entry.target.dataset.origIndex !== undefined
              ? entry.target.dataset.origIndex
              : entry.target.dataset.index
          );
          self._setDesktopActive(origIdx);
        }
      });
    }, { root: null, rootMargin: '-40% 0px -40% 0px', threshold: 0 });

    mainGrid.querySelectorAll('[data-pmg-desk-item]').forEach(function(item) {
      observer.observe(item);
    });

    this._desktopObs = observer;
  }

  _setDesktopActive(origIdx) {
    var thumbWrap = document.getElementById('pmg-desk-thumbs-' + this.id);
    if (!thumbWrap) return;

    thumbWrap.querySelectorAll('[data-pmg-desk-thumb]').forEach(function(t) {
      t.classList.remove('is-active');
    });

    var activeThumb = thumbWrap.querySelector('[data-orig-index="' + origIdx + '"]')
                   || thumbWrap.querySelector('[data-index="' + origIdx + '"]');

    if (activeThumb) {
      activeThumb.classList.add('is-active');
      activeThumb.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
  }

  /* ════════════════════════════════
     MOBILE
  ════════════════════════════════ */
  initMobile() {
    var mobWrap = document.getElementById('pmg-mobile-' + this.id);
    if (!mobWrap) return;
    if (typeof Swiper === 'undefined') return;

    this._initMobileSwiper();
    this._bindMobileThumbs();
  }

  _initMobileSwiper() {
    var self     = this;
    var swiperEl = document.getElementById('pmg-mob-swiper-' + this.id);
    if (!swiperEl) return;

    if (this.mobSwiper) {
      try { this.mobSwiper.destroy(true, true); } catch(e) {}
      this.mobSwiper = null;
    }

    var wrapper = swiperEl.querySelector('.swiper-wrapper');
    if (wrapper) {
      wrapper.style.transform  = '';
      wrapper.style.transition = '';
    }

    requestAnimationFrame(function() {
      self.mobSwiper = new Swiper(swiperEl, {
        slidesPerView: 1.06,
        loop: false,
        spaceBetween: 12,
        allowTouchMove: true,
        observer: false,
        observeParents: false,
        on: {
          slideChange: function(swiper) {
            var activeSlide = swiper.slides[swiper.activeIndex];
            if (!activeSlide) return;
            var origIdx = parseInt(
              activeSlide.dataset.origIndex !== undefined
                ? activeSlide.dataset.origIndex
                : swiper.activeIndex
            );
            self._setMobileActive(origIdx);
          }
        }
      });

      self._setMobileActive(self._getFirstVisibleOrigIndex());
    });
  }

  _getFirstVisibleOrigIndex() {
    var swiperEl = document.getElementById('pmg-mob-swiper-' + this.id);
    if (!swiperEl) return 0;
    var slides = swiperEl.querySelectorAll('.swiper-slide');
    for (var i = 0; i < slides.length; i++) {
      if (slides[i].style.display !== 'none') {
        return parseInt(
          slides[i].dataset.origIndex !== undefined ? slides[i].dataset.origIndex : i
        );
      }
    }
    return 0;
  }

  _bindMobileThumbs() {
    var self      = this;
    var thumbWrap = document.getElementById('pmg-mob-thumbs-' + this.id);
    if (!thumbWrap) return;

    var thumbs = thumbWrap.querySelectorAll('[data-pmg-mob-thumb]');
    thumbs.forEach(function(thumb) {
      var fresh = thumb.cloneNode(true);
      thumb.parentNode.replaceChild(fresh, thumb);

      fresh.addEventListener('click', function() {
        if (!self.mobSwiper) return;

        var origIdx  = parseInt(fresh.dataset.index);
        var swiperEl = document.getElementById('pmg-mob-swiper-' + self.id);
        if (!swiperEl) return;

        var slides   = swiperEl.querySelectorAll('.swiper-slide');
        var slidePos = -1;
        var visCount = 0;

        for (var i = 0; i < slides.length; i++) {
          if (slides[i].style.display === 'none') continue;
          var sOrigIdx = parseInt(
            slides[i].dataset.origIndex !== undefined ? slides[i].dataset.origIndex : i
          );
          if (sOrigIdx === origIdx) {
            slidePos = visCount;
            break;
          }
          visCount++;
        }

        if (slidePos > -1) self.mobSwiper.slideTo(slidePos);
        self._setMobileActive(origIdx);
      });
    });
  }

  _setMobileActive(origIdx) {
    var thumbWrap = document.getElementById('pmg-mob-thumbs-' + this.id);
    if (!thumbWrap) return;

    thumbWrap.querySelectorAll('[data-pmg-mob-thumb]').forEach(function(t) {
      t.classList.remove('is-active');
    });

    var activeThumb = thumbWrap.querySelector('[data-index="' + origIdx + '"]');
    if (activeThumb) {
      activeThumb.classList.add('is-active');
      var stripLeft = thumbWrap.scrollLeft;
      var stripW    = thumbWrap.offsetWidth;
      var thumbLeft = activeThumb.offsetLeft;
      var thumbW    = activeThumb.offsetWidth;
      if (thumbLeft < stripLeft || thumbLeft + thumbW > stripLeft + stripW) {
        thumbWrap.scrollTo({
          left: thumbLeft - stripW / 2 + thumbW / 2,
          behavior: 'smooth'
        });
      }
    }
  }

  reinit() {
    this._bindDesktopThumbs();
    this._observeDesktopScroll();
    this._initMobileSwiper();
    this._bindMobileThumbs();
  }

  static init(sectionId) {
    new ProductMediaGallery(sectionId);
  }

  static getInstance(sectionId) {
    return (ProductMediaGallery._instances || {})[sectionId] || null;
  }
}


/* ─────────────────────────────────────────
   VariantColorGallery
───────────────────────────────────────── */
window.VariantColorGallery = (function() {

  /* ── Extract color part from alt text (before pipe if present) ── */
  function extractAlt(str) {
    if (!str) return '';
    var s = str.indexOf('|') > -1 ? str.split('|')[0] : str;
    return s.toLowerCase().trim();
  }

  function normalize(str) {
    return (str || '').toLowerCase().trim();
  }

  function getColorOptionName() {
    var fieldsets = document.querySelectorAll('.variant_picker');
    for (var i = 0; i < fieldsets.length; i++) {
      var label = fieldsets[i].querySelector('.selected_option');
      if (!label) continue;
      var name = label.textContent.split(':')[0].trim().toLowerCase();
      if (name.indexOf('color')    > -1 || name.indexOf('colour')   > -1 ||
          name.indexOf('metal')    > -1 || name.indexOf('material')  > -1 ||
          name.indexOf('gold')     > -1) {
        return fieldsets[i];
      }
    }
    return null;
  }

  function getSelectedColor(colorPicker) {
    if (!colorPicker) return null;
    var active = colorPicker.querySelector('.option_values.active');
    return active ? active.dataset.value : null;
  }

  function getAllColorValues(colorPicker) {
    if (!colorPicker) return [];
    var labels = colorPicker.querySelectorAll('.option_values');
    var vals   = [];
    for (var i = 0; i < labels.length; i++) {
      var v = labels[i].dataset.value;
      if (v) vals.push(normalize(v));
    }
    return vals;
  }

  /* ── Compute visibility using extracted alt (before pipe) ── */
  function computeVisibility(allAlts, selectedColor, allColors) {
    var matchedColor = [];
    var neutrals     = [];
    var hide         = [];
    var selectedNorm = normalize(selectedColor);

    for (var i = 0; i < allAlts.length; i++) {
      /* Extract color part from alt — before pipe */
      var alt = extractAlt(allAlts[i]);

      /* Blank alt or blank extracted part = neutral */
      if (!alt) {
        neutrals.push(i);
        continue;
      }

      var matchesAnyColor = false;
      var matchesSelected = false;

      for (var ci = 0; ci < allColors.length; ci++) {
        var c = allColors[ci];

        /* Match: alt contains color OR color contains alt (handles partial) */
        if (alt.indexOf(c) > -1 || c.indexOf(alt) > -1) {
          matchesAnyColor = true;
          if (c === selectedNorm ||
              selectedNorm.indexOf(c) > -1 ||
              c.indexOf(selectedNorm) > -1) {
            matchesSelected = true;
          }
          break;
        }
      }

      if (!matchesAnyColor)     neutrals.push(i);     /* no color in alt — neutral, show at end */
      else if (matchesSelected) matchedColor.push(i); /* matches selected — show first */
      else                      hide.push(i);          /* other color — hide */
    }

    /* show = selected color images first, then neutrals at end */
    return { show: matchedColor.concat(neutrals), hide: hide };
  }

  function applyDesktop(sectionId, showIndices, hideIndices) {
    var mainWrap  = document.getElementById('pmg-desk-main-'   + sectionId);
    var thumbWrap = document.getElementById('pmg-desk-thumbs-' + sectionId);
    if (!mainWrap) return;

    /* Show/hide */
    mainWrap.querySelectorAll('[data-pmg-desk-item]').forEach(function(item) {
      var idx = parseInt(item.dataset.origIndex !== undefined ? item.dataset.origIndex : item.dataset.index);
      item.style.display = hideIndices.indexOf(idx) > -1 ? 'none' : '';
    });

    if (thumbWrap) {
      thumbWrap.querySelectorAll('[data-pmg-desk-thumb]').forEach(function(thumb) {
        var idx = parseInt(thumb.dataset.origIndex !== undefined ? thumb.dataset.origIndex : thumb.dataset.index);
        thumb.style.display = hideIndices.indexOf(idx) > -1 ? 'none' : '';
      });
    }

    /* Reorder: selected color first, then neutrals, hidden at end */
    showIndices.forEach(function(idx) {
      var item  = mainWrap.querySelector('[data-orig-index="' + idx + '"],[data-index="' + idx + '"]');
      var thumb = thumbWrap ? thumbWrap.querySelector('[data-orig-index="' + idx + '"],[data-index="' + idx + '"]') : null;
      if (item)  mainWrap.appendChild(item);
      if (thumb) thumbWrap.appendChild(thumb);
    });

    hideIndices.forEach(function(idx) {
      var item  = mainWrap.querySelector('[data-orig-index="' + idx + '"],[data-index="' + idx + '"]');
      var thumb = thumbWrap ? thumbWrap.querySelector('[data-orig-index="' + idx + '"],[data-index="' + idx + '"]') : null;
      if (item)  mainWrap.appendChild(item);
      if (thumb) thumbWrap.appendChild(thumb);
    });
  }

  function applyMobile(sectionId, showIndices, hideIndices) {
    var swiperEl  = document.getElementById('pmg-mob-swiper-' + sectionId);
    var thumbWrap = document.getElementById('pmg-mob-thumbs-'  + sectionId);
    if (!swiperEl) return;

    var gallery = ProductMediaGallery.getInstance(sectionId);
    if (gallery && gallery.mobSwiper) {
      try { gallery.mobSwiper.destroy(true, true); } catch(e) {}
      gallery.mobSwiper = null;
    }

    var wrapper = swiperEl.querySelector('.swiper-wrapper');
    if (!wrapper) return;

    wrapper.style.transform  = '';
    wrapper.style.transition = '';

    /* Show/hide slides */
    wrapper.querySelectorAll('.swiper-slide').forEach(function(slide) {
      var idx = parseInt(slide.dataset.origIndex);
      slide.style.display = hideIndices.indexOf(idx) > -1 ? 'none' : '';
    });

    /* Reorder */
    showIndices.forEach(function(idx) {
      var slide = wrapper.querySelector('.swiper-slide[data-orig-index="' + idx + '"]');
      if (slide) wrapper.appendChild(slide);
    });

    hideIndices.forEach(function(idx) {
      var slide = wrapper.querySelector('.swiper-slide[data-orig-index="' + idx + '"]');
      if (slide) wrapper.appendChild(slide);
    });

    /* Thumbs */
    if (thumbWrap) {
      thumbWrap.querySelectorAll('[data-pmg-mob-thumb]').forEach(function(thumb) {
        var idx = parseInt(thumb.dataset.index);
        thumb.style.display = hideIndices.indexOf(idx) > -1 ? 'none' : '';
      });

      showIndices.forEach(function(idx) {
        var thumb = thumbWrap.querySelector('[data-index="' + idx + '"]');
        if (thumb) thumbWrap.appendChild(thumb);
      });

      hideIndices.forEach(function(idx) {
        var thumb = thumbWrap.querySelector('[data-index="' + idx + '"]');
        if (thumb) thumbWrap.appendChild(thumb);
      });
    }
  }

  function init(sectionId) {

    /* ── Tag stable orig-index on all elements once ── */
    var mobileSwiper = document.getElementById('pmg-mob-swiper-' + sectionId);
    if (mobileSwiper) {
      mobileSwiper.querySelectorAll('.swiper-slide').forEach(function(slide, i) {
        if (slide.dataset.origIndex === undefined) slide.dataset.origIndex = i;
      });
    }

    var mainGrid = document.getElementById('pmg-desk-main-' + sectionId);
    if (mainGrid) {
      mainGrid.querySelectorAll('[data-pmg-desk-item]').forEach(function(item, i) {
        if (item.dataset.origIndex === undefined) item.dataset.origIndex = item.dataset.index || i;
      });
    }

    var deskThumbs = document.getElementById('pmg-desk-thumbs-' + sectionId);
    if (deskThumbs) {
      deskThumbs.querySelectorAll('[data-pmg-desk-thumb]').forEach(function(thumb, i) {
        if (thumb.dataset.origIndex === undefined) thumb.dataset.origIndex = thumb.dataset.index || i;
      });
    }

    /* ── Collect ALL alt texts in original DOM order — do this ONCE ── */
    var allAlts = [];
    if (mainGrid) {
      mainGrid.querySelectorAll('[data-pmg-desk-item]').forEach(function(item) {
        var img = item.querySelector('img');
        allAlts.push(img ? (img.alt || '') : '');
      });
    }

    var colorPicker = getColorOptionName();
    var allColors   = getAllColorValues(colorPicker);

    /* ── Core filter — always re-fetch picker state ── */
    function applyFilter() {
      colorPicker = getColorOptionName();
      allColors   = getAllColorValues(colorPicker);

      var selectedColor = getSelectedColor(colorPicker);

      /* If no color selected — show all, hide nothing */
      if (!selectedColor || !allColors.length) {
        var allIndices = allAlts.map(function(_, i) { return i; });
        applyDesktop(sectionId, allIndices, []);
        applyMobile(sectionId, allIndices, []);
        requestAnimationFrame(function() {
          var gallery = ProductMediaGallery.getInstance(sectionId);
          if (gallery) gallery.reinit();
        });
        return;
      }

      var visibility = computeVisibility(allAlts, selectedColor, allColors);

      applyDesktop(sectionId, visibility.show, visibility.hide);
      applyMobile(sectionId, visibility.show, visibility.hide);

      requestAnimationFrame(function() {
        var gallery = ProductMediaGallery.getInstance(sectionId);
        if (gallery) gallery.reinit();
      });
    }

    /* ── Bind color option clicks ── */
    function bindColorClicks() {
      var cp = getColorOptionName();
      if (!cp) return;
      cp.querySelectorAll('.option_values').forEach(function(label) {
        label.addEventListener('click', function() {
          setTimeout(applyFilter, 10);
        });
      });
    }

    bindColorClicks();

    /* ── Variant change event (from theme) ── */
    document.addEventListener('variant:change', function() {
      setTimeout(applyFilter, 10);
    });

    /* ── Apply on page load ── */
    function applyOnLoad() {
      colorPicker = getColorOptionName();
      allColors   = getAllColorValues(colorPicker);

      var selectedColor = getSelectedColor(colorPicker);

      if (selectedColor) {
        /* Active swatch found immediately */
        applyFilter();
        return;
      }

      /* Check URL for ?variant= param */
      var urlParams = new URLSearchParams(window.location.search);
      var variantId = urlParams.get('variant');

      if (variantId) {
        /* Poll until theme activates the correct swatch */
        var attempts = 0;
        var interval = setInterval(function() {
          attempts++;
          colorPicker = getColorOptionName();
          allColors   = getAllColorValues(colorPicker);
          var color   = getSelectedColor(colorPicker);
          if (color || attempts >= 40) {
            clearInterval(interval);
            if (color) applyFilter();
          }
        }, 100);
      } else {
        /* No variant in URL — wait for theme to activate first swatch */
        setTimeout(function() {
          colorPicker = getColorOptionName();
          allColors   = getAllColorValues(colorPicker);

          if (colorPicker) {
            /* Force-activate first option if nothing active yet */
            var firstOption = colorPicker.querySelector('.option_values');
            if (firstOption && !colorPicker.querySelector('.option_values.active')) {
              firstOption.classList.add('active');
            }
          }
          applyFilter();
        }, 400);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', applyOnLoad);
    } else {
      applyOnLoad();
    }
  }

  return { init: init };

})();




/* ─────────────────────────────────────────
   BsCardSlider
   Initialises Swiper on .bs-card__swiper
   and swatch click logic on .bs-card__swatches
   Works everywhere the snippet is rendered:
   - Page load (static grids)
   - After fetch injection (recommendations, recently viewed)
   - After predictive search injection
   - After any dynamic content via MutationObserver
/* ─────────────────────────────────────────
   BsCardSlider
   - Swiper on .bs-card__swiper
   - Swatch click logic
   - MutationObserver for dynamic content
   - Safe inside predictive search
───────────────────────────────────────── */
class BsCardSlider {

  constructor(el) {
    this.el = el;
    this.initSwiper();
  }

  initSwiper() {
    if (typeof Swiper === 'undefined') return;
    if (this.el._bsSwiper) return;

    var slides = this.el.querySelectorAll('.swiper-slide');
    var count  = slides.length;
    if (count < 1) return;

    /* Detect if inside predictive search */
    var inPredictive = !!this.el.closest(
      '[data-predictive-search], predictive-search, #predictive-search, [data-search-results]'
    );

    /* No loop inside predictive search — loop clones DOM nodes
       which triggers MutationObserver and breaks search close logic */
    var useLoop = count > 1 && !inPredictive;

    var paginationEl = this.el.querySelector('.swiper-pagination');

    this.el._bsSwiper = new Swiper(this.el, {
      slidesPerView: 1,
      loop: useLoop,
      allowTouchMove: count > 1,
      threshold: 10,
      /* Disable Swiper's own observer inside predictive search
         to prevent conflicts with the search container */
      observer: !inPredictive,
      observeParents: !inPredictive,
      pagination: (count > 1 && paginationEl) ? {
        el: paginationEl,
        clickable: true
      } : false
    });
  }

  /* ── Init swatches ── */
  static initSwatches(scope) {
    var root = scope || document;

    root.querySelectorAll('.bs-card__swatches').forEach(function(container) {
      if (container._bsSwatchInit) return;
      container._bsSwatchInit = true;

      var swatches = container.querySelectorAll('.bs-card__swatch');
      swatches.forEach(function(swatch) {
        swatch.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          swatches.forEach(function(s) { s.classList.remove('is-active'); });
          swatch.classList.add('is-active');
        });
      });
    });

    /* Stop pagination clicks from bubbling up to predictive search close handler */
    root.querySelectorAll('.bs-card__swiper .swiper-pagination').forEach(function(pag) {
      if (pag._bsPagInit) return;
      pag._bsPagInit = true;
      pag.addEventListener('click', function(e) {
        e.stopPropagation();
      });
    });
  }

  /* ── Init all uninitialised swipers in scope ── */
  static initAll(scope) {
    var root = scope || document;

    root.querySelectorAll('[data-bs-card-swiper]').forEach(function(el) {
      if (!el._bsSwiper) {
        new BsCardSlider(el);
      }
    });

    BsCardSlider.initSwatches(root);
  }

  /* ── Watch a container for dynamically injected cards ── */
  static observe(container) {
    if (!container || container._bsObserved) return;
    container._bsObserved = true;

    new MutationObserver(function(mutations) {
      var shouldInit = false;

      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType !== 1) return;

          /* Ignore Swiper's own internal DOM changes (cloned slides, wrappers) */
          if (
            node.classList.contains('swiper-slide-duplicate') ||
            node.classList.contains('swiper-notification') ||
            node.closest('[data-bs-card-swiper]')
          ) return;

          shouldInit = true;
        });
      });

      if (shouldInit) {
        /* Small delay to let the DOM settle before initialising */
        setTimeout(function() {
          BsCardSlider.initAll(container);
        }, 50);
      }
    }).observe(container, { childList: true, subtree: true });
  }
}

/* ── Boot on page load ── */
function bsCardSliderBoot() {
  /* Init all cards already in the DOM */
  BsCardSlider.initAll();

  /* Watch known dynamic containers */
  var containers = [
    '[data-predictive-search]',
    'predictive-search',
    'product-recommendations',
    '.recently-viewed',
    '[data-recently-viewed]'
  ];

  containers.forEach(function(selector) {
    document.querySelectorAll(selector).forEach(function(el) {
      BsCardSlider.observe(el);
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bsCardSliderBoot);
} else {
  bsCardSliderBoot();
}



